module.exports = __webpack_public_path__ + "static/media/teach-coding-easy.80b52abe.jpg";